// src/App.tsx

import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'dayjs/locale/tr';
import { SnackbarProvider } from 'notistack';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Guard from './components/Guard';
import Layout from './components/Layout';
import AuthProvider from './contexts/AuthProvider';
import { lightTheme } from './theme';
import Login from './views/Login';
import ComissionRates from './views/admin/ComissionRates';
import Invoices from './views/admin/Invoices';
import LastUsers from './views/admin/LastUsers';
import SellerAddEdit from './views/admin/SellerAddEdit';
import Sellers from './views/admin/Sellers';
import SupplierAddEdit from './views/admin/SupplierAddEdit';
import Suppliers from './views/admin/Suppliers';
import BankAddEdit from './views/common/BankAddEdit';
import Banks from './views/common/Banks';
import CloseIframePage from './views/common/CloseIframePage';
import Root from './views/common/Root';
import UserAddEdit from './views/common/UserAddEdit';
import UserProfile from './views/common/UserProfile';
import Users from './views/common/Users';
import GetPayment from './views/seller/GetPayment';
import SellerProducts from './views/seller/SellerProducts';
import SellerReport from './views/seller/SellerReport';
import SellerSuppliers from './views/seller/SellerSuppliers';
import AdminReport from './views/admin/AdminReport';
import DetailedAdminReport from './views/admin/DetailedAdminReport';
import SellerBranches from './views/seller/SellerBranches';
import DetailedSellerReport from './views/seller/DetailedSellerReport';
import ExternalPayment from './views/ExternalPayment';
import BranchAddEdit from './views/seller/BranchAddEdit';
import ForgotPassword from './views/ForgotPassword';
import PaymentCallbackPage from './views/common/PaymentCallbackPage';
import PaymentSuccessPage from './views/common/PaymentSuccessPage';
import PaymentFailedPage from './views/common/PaymentFailedPage';
import LinkFailedPage from './views/common/PaymentLinkFailedPage';
import LinkSuccessPage from './views/common/PaymentLinkSuccessPage';
import PaymentLinkCallbackPage from './views/common/PaymentLinkCallbackPage';
import HomePage from './website/HomePage';
import LegalText from './views/common/LegalText';

const App = () => {

  return (
    <SnackbarProvider>
      <AuthProvider>
        <ThemeProvider theme={lightTheme}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='tr'>
            <CssBaseline />
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/link-pay/:code" element={<ExternalPayment />} />
                <Route path="/payment/link" element={<PaymentLinkCallbackPage />} />
                <Route path="/payment/link/success" element={<LinkSuccessPage />} />
                <Route path="/payment/link/failed" element={<LinkFailedPage />} />
                <Route path="/" element={<HomePage />} />
              </Routes>
              <Guard>
                <Layout>
                  <Routes>
                    <Route path="/admin/jewelers" element={<Sellers />} />
                    <Route path="/admin/profile" element={<UserProfile />} />
                    <Route path="/admin/jewelers/new" element={<SellerAddEdit />} />
                    <Route path="/admin/jewelers/:id/edit" element={<SellerAddEdit />} />
                    {/* <Route path="/admin/suppliers" element={<Suppliers />} />
                    <Route path="/admin/suppliers/new" element={<SupplierAddEdit />} />
                    <Route path="/admin/suppliers/:id/edit" element={<SupplierAddEdit />} /> */}
                    <Route path="/admin/users" element={<Users />} />
                    <Route path="/admin/reports" element={<AdminReport />} />
                    <Route path="/admin/detailed-reports" element={<DetailedAdminReport />} />
                    <Route path="/admin/users/new" element={<UserAddEdit />} />
                    <Route path="/admin/users/:id/edit" element={<UserAddEdit />} />
                    <Route path="/admin/banks" element={<Banks />} />
                    <Route path="/admin/banks/new" element={<BankAddEdit />} />
                    <Route path="/admin/banks/:id/edit" element={<BankAddEdit />} />
                    <Route path="/admin/transaction-history" element={<LastUsers />} />
                    <Route path="/admin/pos-rates" element={<ComissionRates />} />
                    <Route path="/admin/invoices" element={<Invoices />} />

                    <Route path="/seller" element={<SellerProducts />} />
                    <Route path="/seller/banks" element={<Banks />} />
                    <Route path="/seller/banks/new" element={<BankAddEdit />} />
                    <Route path="/seller/banks/:id/edit" element={<BankAddEdit />} />
                    <Route path="/seller/users" element={<Users />} />
                    <Route path="/seller/users/new" element={<UserAddEdit />} />
                    <Route path="/seller/users/:id/edit" element={<UserAddEdit />} />
                    {/* <Route path="/seller/suppliers" element={<SellerSuppliers />} /> */}
                    <Route path="/seller/branches" element={<SellerBranches />} />
                    <Route path="/seller/branches/new" element={<BranchAddEdit />} />
                    <Route path="/seller/branches/:id/edit" element={<BranchAddEdit />} />
                    {/* <Route path="/seller/products" element={<SellerProducts />} /> */}
                    <Route path="/seller/get-payment" element={<GetPayment />} />
                    <Route path="/seller/profile" element={<UserProfile />} />
                    <Route path="/seller/reports" element={<SellerReport />} />
                    <Route path="/seller/detailed-reports" element={<DetailedSellerReport />} />
                    <Route path="/seller/invoices" element={<Invoices />} />
                    <Route path="/seller/transaction-history" element={<LastUsers />} />
                    <Route path="/seller/get-payment/payment-result" element={<PaymentCallbackPage />} />
                    <Route path="/seller/get-payment/payment-success" element={<PaymentSuccessPage />} />
                    <Route path="/seller/get-payment/payment-failed" element={<PaymentFailedPage />} />
                    <Route path="/legal/:type" element={<LegalText />} />

                    {/* <Route path="/supplier/banks" element={<Banks />} />
                    <Route path="/supplier/banks/new" element={<BankAddEdit />} />
                    <Route path="/supplier/banks/:id/edit" element={<BankAddEdit />} />
                    <Route path="/supplier/users" element={<Users />} />
                    <Route path="/supplier/users/new" element={<UserAddEdit />} />
                    <Route path="/supplier/users/:id/edit" element={<UserAddEdit />} />
                    <Route path="/supplier/suppliers" element={<SellerSuppliers />} /> */}

                  </Routes>
                </Layout>
              </Guard>
            </Router>
          </LocalizationProvider>
        </ThemeProvider>
      </AuthProvider>
    </SnackbarProvider>
  );
};

export default App;
